export const passwordNotContainsEmailError = { passwordContainsEmail: true };

/**
 * Validates that password does not contain the email address or its parts.
 * Uses balanced strictness (>5 character threshold) to minimize false positives.
 *
 * @param password - The password to validate
 * @param email - The user's email address
 * @returns true if password is valid (does not contain email), false otherwise
 */
export function passwordNotContainsEmail(password: string, email: string): boolean {
  if (!password || !email) {
    return true; // Skip validation if either is empty
  }

  const normalizedPassword = password.toLowerCase();
  const normalizedEmail = email.toLowerCase();

  // Check 1: Password equals full email
  if (normalizedPassword === normalizedEmail) {
    return false;
  }

  // Check 2: Password equals email local part (before @)
  const emailLocalPart = normalizedEmail.split('@')[0];
  if (normalizedPassword === emailLocalPart) {
    return false;
  }

  // Check 3: Password contains full email
  if (normalizedPassword.includes(normalizedEmail)) {
    return false;
  }

  // Check 4: Password contains email local part (>5 chars only - BALANCED)
  // This prevents false positives for common short names (e.g., "mike", "john")
  if (emailLocalPart.length > 5 && normalizedPassword.includes(emailLocalPart)) {
    return false;
  }

  return true;
}
